export function useMatchedParams(params, menuData) {
  let matchedPath = Object.values(params);
  if (matchedPath.length >= 3) {
    matchedPath.pop()
  }
  matchedPath = matchedPath.join('/');
  if (matchedPath === "" || matchedPath.includes('settings')) {
    // matchedPath = getDefaulPath(menuData);
    matchedPath = 'settings/personal-details';
  }
  return matchedPath;
}

export function getDefaulPath(menuData) {
  try {
    if (menuData !== null && menuData !== "") {
      let defaultPath = 'settings/personal-details';
      let i = 0;
      do {
        const client = menuData.clients[i];
        let defaultPath = client.clientName.toLowerCase().replaceAll(/\s+/g, "-") + '/';
        if (client.brands && client.brands.length > 0) {
          let k = 0;
          do {
            const brand = client.brands[k];
            defaultPath += (brand.name.toLowerCase().replaceAll(/\s+/g, "-") + '/');
            if ((brand.markets[0] || brand.markets)) {
              const market = (brand.markets[0] || brand.markets);
              defaultPath += (market.name.toLowerCase().replaceAll(/\s+/g, "-") + '/');
              return defaultPath;
            }
            return defaultPath;
            k++;
          } while (k < client.brands.length);  
        }
        i++;
      } while (i < menuData.clients);
     return defaultPath;
    }
  } catch (error) {
    // console.log(error);
    return 'settings/personal-details';
  }

}